/*
 * ******************************************************************
 * Copyright (c) 2023-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Component, HostListener } from "@angular/core";
import { VmwTaskComponent, VmwTasksService } from "@vmw/ngx-components";
import { VmwSimpleTranslateService } from "@vmw/ngx-utils";

// TODO: Remove TaskPanel customization together with the suboptimal inclusion of styles here.
@Component({
    standalone: false,
               selector: "vmw-task-wrap",
               templateUrl: "task-wrap.component.html",
               styleUrls: ["task-wrap.component.scss"]
           })
export class VmwTaskWrapComponent extends VmwTaskComponent {

    constructor(vmwTasksService: VmwTasksService, translateService: VmwSimpleTranslateService) {
        super(vmwTasksService, translateService);
    }

    get showBackButton(): boolean {
        return false;
    }

    @HostListener("click", ["$event"])
    @HostListener("keyup", ["$event"])
    onClick(unused: any): void {
        // Do nothing on click
    }
}
